import axios from 'axios';
import { ROUTES } from 'constants/routes';
import { getUserDummyData } from 'lib/constants/userTestData';
import { useMswManager } from 'lib/util/useMswManager';
import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';
import { ErrorResponse } from 'react-router';
import { HrznGatewayMswBuilder } from 'stories/HrznGatewayMswBuilder';
import { User } from 'types/user';

interface payload {
  username: string;
  password: string;
}

export function useLogin() {
  const snackbar = useSnackbar();

  useMswManager(
    HrznGatewayMswBuilder.create().post(ROUTES.PartnerGetExternalUser, {
      data: getUserDummyData()
    })
  );

  return useMutation<User, ErrorResponse, payload>(
    async ({ username, password }) => {
      const { data } = await axios.post(
        `${process.env.REACT_APP_URL}/?route=PartnerGetExternalUser`,
        {
          userName: username,
          password
        }
      );
      return data;
    },
    {
      onError: err => {
        snackbar.enqueueSnackbar(err.data ?? 'Failed to Login', {
          variant: 'error'
        });
      }
    }
  );
}
